import { Login } from "@/api/interface/index";
import authMenuList from "@/assets/json/authMenuList.json";
import authButtonList from "@/assets/json/authButtonList.json";
import request from '@/config/axios'

/**
 * @name 登录模块
 */
// 用户登录
export const loginApi = (params: Login.ReqLoginForm) => {
  return request.post<Login.ResLogin>({ url: `/login`, data: params });
};
export const forgetEmail = (data: any) => {
  return request.get({ url: "/system/auth/forget/email", params: data });
};
export const forgetCaptcha = (data: any) => {
  return request.get({ url: "/system/auth/forget/captcha/check", params: data });
};

// 注册发送邮件
export const registerEmail = (data: any) => {
  return request.get({ url: "/system/auth/register/email", params: data });
};

//验证注册邮件
export const registerCaptcha = (data: any) => {
  return request.get({ url: "/system/auth/register/captcha/check", params: data });
};

// 验证 Email 是否存在
export const checkEmailExists = (email: string, containerId: string) => {
  return request.get({ url: "/system/auth/email-check", params: { email, containerId } });
};

// 验证 Container ID
export const checkContainerId = (containerId: string) => {
  return request.get({ url: `/system/auth/container-id-check/${containerId}` });
};
export const modifyPassword = (params: any) => {
  return request.post({ url: "/system/auth/forget/password/modify", data: params });
};
// 获取菜单列表
export const getAuthMenuListApi = () => {
  return authMenuList;
};

// 获取按钮权限
export const getAuthButtonListApi = () => {
  return authButtonList;
};

// 用户退出登录
export const logoutApi = () => {
  return request.delete({ url: "/system/auth/logout" });
};

// 发送 邮件
export const forgetEmailApi = () => {
  return request.get({ url: "system/auth/forget/email" });
};

// 修改密码

// 注册
export const registerApi = (params: any) => {
  return request.post({ url: "/system/auth/register", data: params });
};

// 获取验证码
export const codeApi = () => {
  return request.get({ url: "/code" });
};
